import { createSelector } from 'reselect'

const layoutReducerLoadingSelector = state => state.layoutReducer.getIn(["loading"])
export const loadingSelector = createSelector(
  layoutReducerLoadingSelector, (loadingField) => {    
    return loadingField
  }
)

const layoutReducerHeaderSelector = state => state.layoutReducer.getIn(["header"]).toJS()
export const headerSelector = createSelector(
  layoutReducerHeaderSelector, (headerField) => {    
    return headerField
  }
)